import { useQueryClient } from '@tanstack/react-query'
import { ColumnPreset } from 'models/column_preset'
import { toast } from 'react-toastify'
import { updateColumnPreset } from 'services/column_presets_api'
import {
  ColumnPresetFormData,
  ColumnPresetModal,
} from 'components/Filters/saved-filters/ColumnPresetModal'

interface EditColumnPresetModalProps {
  show: boolean
  handleClose: () => void
  columnPreset: ColumnPreset | null
  onPresetUpdated?: () => void
}

export function EditColumnPresetModal({
  show,
  handleClose,
  columnPreset,
  onPresetUpdated,
}: EditColumnPresetModalProps) {
  const queryClient = useQueryClient()

  const handleSubmitSuccess = () => {
    toast.success('Column preset updated!')
    onPresetUpdated?.()
  }

  const updatePreset = async (values: ColumnPresetFormData) => {
    if (!columnPreset) return

    await updateColumnPreset(columnPreset.id, {
      name: values.name,
      shared: values.shared,
    })

    // Invalidate column presets for the specific identifier
    await queryClient.invalidateQueries({
      queryKey: ['column_presets', columnPreset.identifier],
    })

    // Invalidate all column presets (for settings table)
    await queryClient.invalidateQueries({
      queryKey: ['column-presets/'],
    })
  }

  return (
    <ColumnPresetModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Update"
      submitApiAction={updatePreset}
      columnPresetToEdit={columnPreset}
      title="Edit Column Preset"
      description="Update the preset name and sharing settings."
    />
  )
}
